
<template>
    <div id="odds_changes">
      <div id="teamHeader">
        <h3>{{teamData.matchTime}} {{teamData.matchCompetition}} Round {{teamData.matchRound}}</h3>
        <div class="left" v-if="teamData.teamA">
            <span class="text_lim">{{teamData.teamA.name}}</span>
            <img :src="getImgSrc(teamData.teamA.logo)" @error="showDefault($event)"
                 alt=""/>
        </div>
        <div class="mid">
            VS
        </div>
        <div class="right" v-if="teamData.teamB">
            <img :src="getImgSrc(teamData.teamB.logo)" @error="showDefault($event)"
                 alt=""/>
            <span class="text_lim">{{ teamData.teamB.name }}</span>
        </div>
      </div>
      <nav>
          <span>{{$t("odds_company")}}</span>
          <span>{{$t("odds_dc")}}</span>
      </nav>
      <div class="main">
          <aside class="menu">
              <span :class="{'sel':index===currentSelectedCompanyIdIndex}" v-for="(item,index) in betList" :key="index" @click="changeNav(item.company.companyId,index)">{{item.company.name}}</span>
          </aside>
          <article>
              <table>
                <tr v-for="(item,index) in currentData" :key="index">
                  <td class="firstTd">
                      <span class="frist" v-if="index == (currentData.length-1)">{{$t("odds_initial")}}</span>
                      {{oddsFormat(item.homeWin)}}
                  </td>
                  <td>{{oddsFormat(item.draw)}}</td>
                  <td>{{oddsFormat(item.awayWin)}}</td>
                  <td>{{item.time}}</td>
                </tr>
              </table>
          </article>
      </div>
    </div>
</template>
<script>
    import messages from '@/lang/oddsChanges';
    // import browers from '@/util/browers';
    import i18n from '@/util/i18n';
    import axios from 'axios';

    let Fraction = require('fraction.js');
    // const getParameterByName = function (name, url) { //
    //     if (!url) url = window.location.href;
    //     name = name.replace(/[[\]]/g, '\\$&');
    //     var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    //     var results = regex.exec(url);
    //     if (!results) return null;
    //     if (!results[2]) return '';
    //     return decodeURIComponent(results[2].replace(/\+/g, ' '));
    // };
    // const matchId = getParameterByName('matchId');
    // const urlCompanyId = getParameterByName('companyId');
    // const urlType = getParameterByName('type');
    // const urlRate = getParameterByName('rate');

    export default {
        i18n,
        name: 'odds_changes',
        data () {
            return {
                // teamData: {},
                betList: [],
                currentSelectedCompanyIdIndex: 0,
                currentData: [],
                matchId: '',
                urlCompanyId: '',
                urlType: '',
                urlRate: ''
            };
        },
        computed: {
            teamData: {
                get: function () {
                    return this.$store.state.oddsChange || {};
                },
                set: function (newValue) {
                    this.$store.state.oddsChange = newValue;
                }
            }
        },
        created () {
            const matchId = this.matchId = this.$route.query.matchId;
            const urlCompanyId = this.urlCompanyId = this.$route.query.companyId;
            const urlType = this.urlType = this.$route.query.type;
            const urlRate = this.urlRate = this.$route.query.rate;
            Object.keys(messages).map(locale => i18n.setLocaleMessage(locale, messages[locale]));
            // global.apiDomain = '//beta-m.allfootballapp.com';
            // axios.get(`${global.apiDomain}/api/data/odds/detail/${matchId}?companyId=${urlCompanyId}&type=${urlType}&rate=${urlRate}&language=${i18n.locale}`).then((res) => {
            axios.get(`${global.apiDomain}/api/data/odds/detail/${matchId}?companyId=${urlCompanyId}&type=${urlType}&rate=${urlRate}&language=${i18n.locale}`).then((res) => {
                this.teamData = res.data.teamData;
                if (res.data.betList) {
                    this.betList = res.data.betList;
                    for (let i = 0; i < this.betList.length; i++) {
                        if (urlCompanyId === this.betList[i].company.companyId) {
                            this.currentSelectedCompanyIdIndex = i;
                        }
                    }
                    this.currentData = this.betList[this.currentSelectedCompanyIdIndex].company.detail;
                }
            }, () => {
                console.log('未获取到数据～');
            });
            // this.$store.dispatch('FETCH_ODDSCHANGE', {
            //     id: matchId,
            //     companyId: urlCompanyId,
            //     type: urlType,
            //     rate: urlRate
            // });
        },
        methods: {
            showDefault (team) {
                let defaultImg = require('@/assets/matchOdds/defaultTeam.png');
                event.target.src = defaultImg;
            },
            oddsFormat (odds) { // 给数据做分数、小数格式转换
                var currentRate = this.urlRate;
                if (/^\d+(\.\d+)?$/.test(odds.toString())) {
                    if (currentRate === 'American') {
                        if (odds >= 2) {
                            return Math.floor((odds - 1) * 100);
                        } else {
                            return Math.floor(100 / (1 - odds));
                        }
                    }
                    if (currentRate === 'Fractional') {
                        return new Fraction(odds).toFraction();
                    }
                }
                return odds;
            },
            changeNav (companyId, index) {
                this.currentSelectedCompanyIdIndex = index;
                axios.get(`${global.apiDomain}/api/data/odds/detail/${this.matchId}?companyId=${companyId}&type=${this.urlType}&rate=${this.urlRate}`).then((res) => {
                    if (res.data.betList) {
                        this.currentData = res.data.betList[this.currentSelectedCompanyIdIndex].company.detail;
                    }
                }, () => {
                    console.log('未获取到数据～');
                });
            }
        }
    };
</script>
<style scoped lang="less">
    body {
        margin: 0;
        padding: 0;
        width: 100%;
        background: #f5f5f5;
        font-size: 0.675;
        -webkit-font-smoothing: antialiased;
        position: relative;
    }

    table {
        border-collapse: collapse;
        width: 100%;
    }

    #teamHeader {
        width: 100%;
        text-align: center;
        color: #fff;
        height: 85px;
        font-size: 0;
        background: url('../assets/matchOdds/header.jpg') 0 0 no-repeat;
        background-size: cover;
    }

    #teamHeader h3 {
        padding-top: 10px;
        margin: 0;
        height: 30px;
        line-height: 30px;
        font-size: 13px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    #teamHeader div {
        display: inline-block;
        height: 40px;
        line-height: 40px;
        width: 40%;
    }

    #teamHeader div.left {
        text-align: right;
        font-size: 16px;
    }

    #teamHeader div.right {
        text-align: left;
        font-size: 16px;
    }

    #teamHeader div.mid {
        text-align: center;
        font-size: 16px;
        width: 19%;
    }

    #teamHeader img {
        vertical-align: middle;
        width: 26px;
        height: 26px;
    }

    /*#listMain {
        display: none;
    }*/

    nav {
        width: 100%;
        margin: 0 0 10px 0;
        padding: 0;
        height: 36px;
        line-height: 36px;
        background: #fff;
        border-bottom: 1px solid #ddd;
        font-size: 0;
    }

    nav span {
        display: inline-block;
        height: 36px;
        line-height: 36px;
        text-align: center;
        font-size: 14.4px;
    }

    nav span:nth-child(1) {
        width: 25%;
    }

    nav span:nth-child(2) {
        width: 73%;
    }

    aside {
        width: 25%;
        display: inline-block;
        vertical-align: top;
        font-size: 1rem;
    }

    aside span {
        display: block;
        height: 40px;
        padding-bottom: 2px;
        line-height: 40px;
        font-size: 14.4px;
        text-align: center;
        border-bottom: 1px solid #ddd;
        border-right: 1px solid #ddd;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    aside span.sel {
        color: #16ac3a;
        padding-bottom: 0;
        border-bottom: 2px solid #16c63a;
        border-right: 0;
    }

    article {
        width: 71%;
        margin: 0 1% 0 3%;
        display: inline-block;
        vertical-align: top;
        font-size: 16px;
    }

    .main {
        font-size: 0;
        min-height: 100%;
        letter-spacing: 0;
        border-top: 1px solid #ddd;
        background: #fff;
    }

    .main article {
        background: url('../assets/matchOdds/bg.png') 0 0 repeat-x;
        background-size: 100% auto;
        background-image: -webkit-linear-gradient(to bottom, #effff3, #8feba5);
        background-image: linear-gradient(to bottom, #effff3, #8feba5);
    }

    .main article table {
        width: 99%;
        margin: 0 auto;
    }

    .main article table tr td:first {
        width: 16%;
    }

    .main article table td {
        height: 50px;
        position: relative;
        border-bottom: 1px solid #b3dcbd;
        text-align: center;
        font-size: 13px;
    }

    .main td .frist {
        position: absolute;
        top: 0;
        left: 0;
        background: #ff6529;
        border-radius: 3px;
        color: #fff;
        font-size: 12px;
        transform-origin: 0 0;
        transform: scale(0.7);
        padding: 0 2px;
    }

    /*article table {
        display: none;
    }

    article table.show {
        display: table;
    }*/

    span.text_lim {
        display: inline-block;
        white-space: nowrap;
        font-size: 14px;
        height: 14px;
        line-height: 14px;
        line-break: strict;
        vertical-align: middle;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 90px;
        text-overflow: ellipsis;
    }

    .firstTd {
        width: 80px;
    }

</style>



// WEBPACK FOOTER //
// AppMatchOdds.vue?3dbebcdc